module.exports = __webpack_public_path__ + "img/bw.63351ba4.svg";